import {
  Layout,
  Smartphone,
  Shield,
  Zap,
  Target,
  Users,
  CreditCard,
  BarChart3,
  Truck,
  Boxes,
  FileText,
  UserPlus,
  Calendar,
  Wallet,
  Package,
  ShoppingCart,
  Wrench,
  UserCheck,
  ClipboardList,


} from "lucide-react";

const IMAGE = "https://miniapptech.in/assets/img/products";
export const PRODUCTS = [
  {
    id: 1,
    slug: "neelo-commerce",
    name: "Neelo",
    tagline: "Quick Commerce Platform",
    description:
      "Hyperlocal ordering & delivery solution for modern retail businesses. Scale your local delivery operations with enterprise-grade tech.",
    icon: "🛍️",
    color: "from-purple-100 to-purple-50",
    image:
      "https://images.unsplash.com/photo-1557821552-17105176677c?w=1200&q=80",
    features: [
      {
        icon: Layout,
        title: "Order Management",
        desc: "Centralized dashboard for processing orders from multiple channels.",
      },
      {
        icon: Truck,
        title: "Delivery Tracking",
        desc: "Real-time GPS tracking for delivery partners and customer updates.",
      },
      {
        icon: Layout,
        title: "Store Dashboard",
        desc: "Powerful tools for store managers to handle inventory and staff.",
      },
      {
        icon: Smartphone,
        title: "Customer App",
        desc: "Intuitive mobile experience for seamless browsing and checkout.",
      },
    ],
    benefits: [
      "Launch your hyperlocal store in less than 48 hours",
      "Reduce delivery turnaround time by 30%",
      "Integrated loyalty and reward systems",
      "Seamless mobile-first shopping experience",
    ],
    targetAudience: [
      "Supermarkets and Groceries",
      "Pharmacies",
      "Local Retail Chains",
      "Restaurant Networks",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?w=800&q=80",
      "https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=800&q=80",
    ],
  },
  {
    id: 2,
    slug: "construction-mgmt",
    name: "Construction Management",
    tagline: "Build with Precision",
    description:
      "Complete project and site management system designed for builders, contractors, and civil engineers to digitize their sites.",
    icon: "🏗️",
    color: "from-orange-100 to-orange-50",
    image: "/assets/img/Construction.jpg",
    features: [
      {
        icon: BarChart3,
        title: "Site Progress Tracking",
        desc: "Monitor daily progress with photo updates and milestone tracking.",
      },
      {
        icon: Boxes,
        title: "Material Monitoring",
        desc: "Track inward/outward material flow and prevent site wastage.",
      },
      {
        icon: Users,
        title: "Labour Management",
        desc: "Manage attendance, shifts, and daily wages for your workforce.",
      },
      {
        icon: CreditCard,
        title: "Cost Control",
        desc: "Real-time budget vs. actual cost analysis for every project phase.",
      },
    ],
    benefits: [
      "Eliminate project delays with real-time site updates",
      "Reduce material wastage by up to 15%",
      "Simplified reporting for stakeholders and clients",
      "Centralized document management for site plans",
    ],
    targetAudience: [
      "Real Estate Developers",
      "Civil Contractors",
      "Interior Design Firms",
      "Infrastructure Companies",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80",
      "https://images.unsplash.com/photo-1503387762-592dea58ef21?w=800&q=80",
    ],
  },
  {
    id: 3,
    slug: "stock-mgmt",
    name: "Stock Management System",
    tagline: "Smart Inventory Tracking",
    description:
      "Advanced inventory and warehouse tracking software to optimize your supply chain and prevent stock-outs or overstocking.",
    icon: "📦",
    color: "from-blue-100 to-blue-50",
    image:
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&q=80",
    features: [
      {
        icon: Zap,
        title: "Real-time Updates",
        desc: "Sync inventory levels across multiple warehouses and storefronts instantly.",
      },
      {
        icon: Target,
        title: "Low Stock Alerts",
        desc: "Automated notifications when products hit minimum threshold levels.",
      },
      {
        icon: BarChart3,
        title: "Purchase & Sales",
        desc: "Track every transaction and its impact on inventory valuation.",
      },
      {
        icon: FileText,
        title: "Reports & Analytics",
        desc: "Deep insights into stock rotation and high-performing products.",
      },
    ],
    benefits: [
      "Maintain perfect stock levels across all locations",
      "Automate purchase order generation",
      "Reduce dead stock through ageing analysis",
      "Cloud-based access from any device",
    ],
    targetAudience: [
      "Wholesalers and Distributors",
      "E-commerce Sellers",
      "Manufacturing Units",
      "Retail Store Owners",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1553413077-190dd305871c?w=800&q=80",
      "https://images.unsplash.com/photo-1460925895917-adf4e5542483?w=800&q=80",
    ],
  },
  {
    id: 4,
    slug: "billing-software",
    name: "Online Billing Software",
    tagline: "GST Billing & Automation",
    description:
      "Professional GST billing and invoice automation software to simplify your business finances and tax compliance.",
    icon: "🧾",
    color: "from-green-100 to-green-50",
    image: "/assets/img/online-bill.jpg",
    features: [
      {
        icon: FileText,
        title: "Quick Invoicing",
        desc: "Generate professional, GST-compliant invoices in seconds.",
      },
      {
        icon: Wallet,
        title: "Expense Tracking",
        desc: "Monitor your business expenses and categorize for tax deductions.",
      },
      {
        icon: Shield,
        title: "Tax Reports",
        desc: "Auto-generate GSTR reports and financial statements.",
      },
      {
        icon: CreditCard,
        title: "Payment Tracking",
        desc: "Manage receivables and send automated payment reminders.",
      },
    ],
    benefits: [
      "100% GST compliance guaranteed",
      "Get paid faster with digital payment links",
      "Reduce accounting errors through automation",
      "Professional branding on all documents",
    ],
    targetAudience: [
      "Service Providers",
      "Freelancers",
      "MSME Businesses",
      "Trading Companies",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
      "https://images.unsplash.com/photo-1554224155-1696413575b3?w=800&q=80",
    ],
  },
  {
    id: 5,
    slug: "lead-followup",
    name: "Lead & Follow-Up Management",
    tagline: "Boost Your Sales Conversion",
    description:
      "Never miss a potential client again. A specialized CRM tool focused on lead intake and persistent follow-up management.",
    icon: "🧲",
    color: "from-red-100 to-red-50",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
    features: [
      {
        icon: UserPlus,
        title: "Lead Assignment",
        desc: "Capture leads from web, social, and calls; assign to sales reps.",
      },
      {
        icon: Calendar,
        title: "Follow-up Reminders",
        desc: "Smart notifications to ensure team stays in touch with prospects.",
      },
      {
        icon: Target,
        title: "Sales Tracking",
        desc: "Visual sales pipeline to track lead movement through stages.",
      },
      {
        icon: BarChart3,
        title: "Conversion Reports",
        desc: "Analyze source performance and team efficiency metrics.",
      },
    ],
    benefits: [
      "Increase sales conversion rates by up to 25%",
      "Complete visibility into the sales pipeline",
      "Reduce lead response time significantly",
      "Mobile app for sales teams on the field",
    ],
    targetAudience: [
      "Sales Agencies",
      "Real Estate Builders",
      "Education Consultants",
      "Financial Advisory Firms",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1460925895917-adf4e5542483?w=800&q=80",
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
    ],
  },
  {
    id: 6,
    slug: "project-mgmt",
    name: "Project Management",
    tagline: "Collaborate and Deliver",
    description:
      "Robust task and project management software for modern teams to plan, track, and execute work efficiently.",
    icon: "📅",
    color: "from-cyan-100 to-cyan-50",
    image:
      "https://images.unsplash.com/photo-1531403009284-440f080d1e12?w=1200&q=80",
    features: [
      {
        icon: Layout,
        title: "Task Assignment",
        desc: "Break projects into tasks, assign owners, and set priority levels.",
      },
      {
        icon: Calendar,
        title: "Timeline Planning",
        desc: "Gantt charts and timelines to visualize project schedules.",
      },
      {
        icon: Users,
        title: "Team Collaboration",
        desc: "Internal chat and document sharing within project contexts.",
      },
      {
        icon: BarChart3,
        title: "Performance Monitoring",
        desc: "Track team productivity and individual performance metrics.",
      },
    ],
    benefits: [
      "Improve team transparency and accountability",
      "Meet project deadlines more consistently",
      "Centralize all project-related communication",
      "Scale from small teams to large enterprises",
    ],
    targetAudience: [
      "IT & Software Agencies",
      "Marketing Firms",
      "Corporate Departments",
      "Remote-first Teams",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1454165833767-02755177aa70?w=800&q=80",
      "https://images.unsplash.com/photo-1542744095-2ad4870b62ef?w=800&q=80",
    ],
  },
  {
    id: 7,
    slug: "finance-mgmt",
    name: "Finance Management",
    tagline: "Secure EMI & Collection Management",
    description:
      "Specialized software for daily, weekly, and monthly collection businesses to manage EMIs and agent field operations.",
    icon: "💰",
    color: "from-amber-100 to-amber-50",
    image: "/assets/img/finance_sw.png",
    features: [
      {
        icon: Wallet,
        title: "Collection Tracking",
        desc: "Monitor daily, weekly, and monthly collections in real-time.",
      },
      {
        icon: Smartphone,
        title: "Agent Monitoring",
        desc: "Field agent app with GPS tracking and instant receipt generation.",
      },
      {
        icon: Target,
        title: "Due Management",
        desc: "Automated due lists and penalty management for defaulters.",
      },
      {
        icon: BarChart3,
        title: "Financial Reports",
        desc: "Comprehensive cash book, ledger, and performance analytics.",
      },
    ],
    benefits: [
      "Zero leakage in field collections",
      "Real-time visibility of cash in hand",
      "Reduce bad debts with proactive alerts",
      "Mobile app works offline for distant areas",
    ],
    targetAudience: [
      "Microfinance Institutions",
      "EMI Collection Agencies",
      "Vehicle Finance Companies",
      "Local Lending Businesses",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1554224155-1696413575b3?w=800&q=80",
      "https://images.unsplash.com/photo-1580519542036-c47de6196ba5?w=800&q=80",
    ],
  },
  {
    id: 8,
    slug: "chitfund-mgmt",
    name: "Chit Fund Management",
    tagline: "Digitize Your Chit Business",
    description:
      "Fully automated chit fund management software ensuring transparency, legal compliance, and easy ledger management.",
    icon: "🏦",
    color: "from-indigo-100 to-indigo-50",
    image:
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1200&q=80",
    features: [
      {
        icon: Users,
        title: "Member Management",
        desc: "Digitize member profiles, eligibility, and group assignments.",
      },
      {
        icon: Zap,
        title: "Auction Handling",
        desc: "Manage digital auctions, dividend calculations, and bid history.",
      },
      {
        icon: Wallet,
        title: "Installment Tracking",
        desc: "Track payments and send automated reminders to members.",
      },
      {
        icon: BarChart3,
        title: "Ledger & Reporting",
        desc: "Detailed financial statements for transparency and audit.",
      },
    ],
    benefits: [
      "Complete transparency for all members",
      "Legal compliance made easy",
      "Automated auction and dividend engine",
      "Member portal for real-time account status",
    ],
    targetAudience: [
      "Registered Chit Fund Companies",
      "Community Chit Groups",
      "Self Help Groups (SHG)",
      "Financial Cooperatives",
    ],
    screenshots: [
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&q=80",
      "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=800&q=80",
    ],
  },
  {
    id: 9,
    slug: "ERP-mgmt",
    name: "Introducing Our ERP Software for Solar Dealers ",
    tagline: "Complete ERP Solution with Mobile App for Field Visit Staff",
    description: `
At MiniAppTech, we've built a complete ERP solution designed specifically for solar dealers, distributors, and EPC companies.
Our solution helps you manage your entire business from a single platform while empowering your field team with a dedicated mobile app.
`,
    icon: "☀️",
    color: "from-yellow-100 to-orange-50",
    image: `${IMAGE}/Solar ERP.png`,
    features: [
      {
        icon: Users,
        title: "Lead & Enquiry Management",
        desc: "Capture, organize, and track customer enquiries efficiently.",
      },
      {
        icon: FileText,
        title: "Sales & Quotation Management",
        desc: "Create professional quotations and manage the complete sales process.",
      },
      {
        icon: Package,
        title: "Inventory & Stock Management",
        desc: "Monitor inventory, stock movement, and material availability in real time.",
      },
      {
        icon: ShoppingCart,
        title: "Purchase & Billing",
        desc: "Manage purchases, invoices, billing, and supplier records with ease.",
      },
      {
        icon: Wrench,
        title: "Installation & Project Tracking",
        desc: "Track installation progress, project status, and team assignments.",
      },
      {
        icon: UserCheck,
        title: "Customer & Service Management",
        desc: "Maintain customer records, service requests, and support history.",
      },
      {
        icon: ClipboardList,
        title: "Employee Task Management",
        desc: "Assign tasks, monitor employee performance, and manage field operations.",
      },
      {
        icon: BarChart3,
        title: "Reports & Business Analytics",
        desc: "Generate detailed reports and business insights for better decision-making.",
      },
      {
        icon: Smartphone,
        title: "Field Visit Mobile App",
        desc: "Daily visit planning, GPS tracking, customer check-in/out, photo reports, installation updates, follow-up management, and real-time ERP synchronization.",
      },
    ],

    benefits: [
      "Manage your entire solar business from one platform",
      "Improve productivity with a dedicated field staff mobile app",
      "Real-time GPS tracking and visit reporting",
      "Faster quotation, billing, and project execution",
      "Better customer service and follow-up management",
      "Powerful reports and business analytics",
    ],

    targetAudience: [
      "Solar Dealers",
      "Solar Distributors",
      "Solar EPC Companies",
      "Solar Installation Businesses",
    ],

    screenshots: [
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
    "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&q=80",
  
]
  },
];
